import { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { PageContainer } from '../../../components/PageContainer';
import { NotFound } from '../../../components/NotFound';
import { Card, Dropdown, Form } from 'react-bootstrap';
import { findInList, numberDisplay } from '../../../services/formats';
import { useUtility } from '../../../contexts/UtilityContext';
import { Modal } from '../../../components/Modal';
import { fetchItemList, ItemModel } from '../../../model/item.model';
import { ItemForm } from './item-form';
import StatusBadge from '../../../components/StatusBadge';
import { Master } from '../../../model/masters.model';
import { Actions } from '../../../components/Actions';

export default function ItemList() {
  const [list, setList] = useState<Array<ItemModel>>([]);
  const [filterList, setFilterList] = useState<Array<ItemModel>>([]);
  const [groups, setGroups] = useState<Array<Master>>([]);
  const [types, setTypes] = useState<Array<Master>>([]);
  const { authInfo } = useAuth();
  const { isLoading, showLoader, hideLoader, confirm } = useUtility();
  const [selectedItem, setSelectedItem] = useState<ItemModel>();

  function handleEdit(item: ItemModel) {
    setSelectedItem({
      ...item,
      group: groups.find(g => g.id === item.group_id),
    });
  }

  async function handleDelete(item: ItemModel) {
    try {
      const isConfirmed = await confirm(`Are you want to delete the Item: ${item.item_name}`);
      if (isConfirmed && item.id) {
        // await deleteItem(item.id, authInfo);
        setList(prev => prev.filter(p => p.id !== item.id));
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        const res = await fetchItemList(authInfo);
        setGroups(res.masters.groups);
        setTypes(res.masters.types);
        setList(res.data);
        setFilterList(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo]);
  return (
    <>
      <PageContainer
        title="Item Master"
        addButtonHandler={() => setSelectedItem({} as ItemModel)}
        body={
          !isLoading && list.length === 0 ? <NotFound /> : <>
          <Form.Group className="mb-3" controlId="itemSearch">
              <Form.Control
                type="text"
                placeholder="Search by item name..."
                onChange={(e) => {
                  const keyword = e.target.value.toLowerCase();
                  setFilterList(
                    list.filter(item => item.item_name.toLowerCase().includes(keyword))
                  );
                }}
              />
            </Form.Group>
            {filterList.map((item, index) => (
              <Card key={`card-${index}`} className="mb-3">
                <Card.Body>
                  <Card.Title className="d-flex justify-content-between align-items-center">
                    <h5>{item.item_name}</h5>
                    <Actions index={index}>
                      <Dropdown.Item onClick={() => handleEdit(item)}>Edit</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(item)}>Delete</Dropdown.Item>
                    </Actions>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    <StatusBadge value={item.publish} />
                  </Card.Subtitle>
                  <Card.Text className='d-flex justify-content-between align-items-center'>
                    <span className='text-start'>Type: {findInList(types, item.item_type)}</span>
                    <span className='text-end'>Group: {findInList(groups, item.group_id)}</span>
                  </Card.Text>
                  <Card.Text className='d-flex justify-content-between align-items-center'>
                    <span className='text-center'>Sale Rate<br />{numberDisplay(item.si_rate)}</span>
                    <span className='text-center'>Purchase Rate<br />{numberDisplay(item.pi_rate)}</span>
                    <span className='text-center'>PO Rate<br />{numberDisplay(item.po_rate)}</span>
                    <span className='text-center'>SO Rate<br />{numberDisplay(item.so_rate)}</span>
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </>
        }
      />
      <Modal
        title={selectedItem?.item_name ?? "Item Master"}
        show={!!selectedItem}
        handleClose={() => setSelectedItem(undefined)}
        fullscreen
      >
        <ItemForm
          item={selectedItem}
          types={types}
          groups={groups}
          onSuccess={(item) => {
            setList(prev => {
              const exists = prev.findIndex(p => p.id === item.id);
              if (exists !== -1) {
                const updated = [...prev];
                updated[exists] = item;
                return updated;
              }
              return [...prev, item];
            });
            setSelectedItem(undefined);
          }}
        />
      </Modal>
    </>
  );
};